import { render, staticRenderFns } from "./NotificationSettingsModal.vue?vue&type=template&id=d0e3c238&"
import script from "./NotificationSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationSettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports